import LearningProgramMilestoneObjDetails from "./LearningProgramMilestoneObjDetails";

export default LearningProgramMilestoneObjDetails;
